import { useEffect, useState } from "react";
import { PublicKey, Transaction } from "@solana/web3.js";
import * as React from "react";
import { Buffer } from "buffer";
window.Buffer = window.Buffer || Buffer

type DisplayEncoding = "utf8" | "hex";
type PhantomEvent = "disconnect" | "connect" | "accountChanged";
type PhantomRequestMethod =
  | "connect"
  | "disconnect"
  | "signTransaction"
  | "signAllTransactions"
  | "signMessage";

interface ConnectOpts {
  onlyIfTrusted: boolean;
}

interface PhantomProvider {
  publicKey: PublicKey | null;
  isConnected: boolean | null;
  signTransaction: (transaction: Transaction) => Promise<Transaction>;
  signAllTransactions: (transactions: Transaction[]) => Promise<Transaction[]>;
  signMessage: (
    message: Uint8Array | string,
    display?: DisplayEncoding
  ) => Promise<any>;
  connect: (opts?: Partial<ConnectOpts>) => Promise<{ publicKey: PublicKey }>;
  disconnect: () => Promise<void>;
  on: (event: PhantomEvent, handler: (args: any) => void) => void;
  request: (method: PhantomRequestMethod, params: any) => Promise<unknown>;
  isPhantom?: boolean; // Add this property to avoid TypeScript errors
}

declare global {
  interface Window {
    solana?: PhantomProvider;
  }
}

interface InitProps {
  connect: boolean;
  onAddressChange: (address: string) => void;
}

function PhantomWallet(props: InitProps) {
  const [provider, setProvider] = useState<PhantomProvider | undefined>(
    undefined
  );
  const [walletKey, setWalletKey] = useState<string | undefined>(undefined);

  /**
   * @description gets Phantom provider, if it exists
   */
  const getProvider = (): PhantomProvider | undefined => {
    if ("solana" in window) {
      const provider = window.solana;
      if (provider?.isPhantom) return provider;
    }
  };

  /**
   * @description prompts user to connect wallet if it exists
   */
  const connectWallet = async () => {
    const { solana } = window;

    if (solana) {
      try {
        const response = await solana.connect();
        setWalletKey(response.publicKey.toString());
        props.onAddressChange(response.publicKey.toString());
      } catch (err) {
        disconnectWallet();
        props.onAddressChange("");
      }
    }
  };

  /**
   * @description disconnect Phantom wallet
   */
  const disconnectWallet = async () => {
    const { solana } = window;

    if (walletKey && solana) {
      await solana.disconnect();
      setWalletKey(undefined);
      localStorage.clear();
    }
  };

  // detect phantom provider exists
  useEffect(() => {
    const provider = getProvider();

    if (provider) setProvider(provider);
    else setProvider(undefined);
  }, []);

  useEffect(() => {
    if (props.connect) {
      connectWallet();
    }
  }, [props.connect]);

  useEffect(() => {
    if (walletKey) disconnectWallet();
  }, [walletKey]);

  return <></>;
}

export default PhantomWallet;

// import { useEffect, useState } from "react";
// import { PublicKey, Transaction } from "@solana/web3.js";
// import * as React from "react";

// type DisplayEncoding = "utf8" | "hex";
// type PhantomEvent = "disconnect" | "connect" | "accountChanged";
// type PhantomRequestMethod =
//     | "connect"
//     | "disconnect"
//     | "signTransaction"
//     | "signAllTransactions"
//     | "signMessage";

// interface ConnectOpts {
//     onlyIfTrusted: boolean;
// }

// interface PhantomProvider {
//     publicKey: PublicKey | null;
//     isConnected: boolean | null;
//     signTransaction: (transaction: Transaction) => Promise<Transaction>;
//     signAllTransactions: (transactions: Transaction[]) => Promise<Transaction[]>;
//     signMessage: (
//         message: Uint8Array | string,
//         display?: DisplayEncoding
//     ) => Promise<any>;
//     connect: (opts?: Partial<ConnectOpts>) => Promise<{ publicKey: PublicKey }>;
//     disconnect: () => Promise<void>;
//     on: (event: PhantomEvent, handler: (args: any) => void) => void;
//     request: (method: PhantomRequestMethod, params: any) => Promise<unknown>;
// }


// interface InitProps {
//     connect: boolean;
//     onAddressChange: (address: String) => void;
// }

// function PhantomWallet(props: InitProps) {
//     const [provider, setProvider] = useState<PhantomProvider | undefined>(
//         undefined
//     );
//     const [walletKey, setWalletKey] = useState<string | undefined>(
//         undefined
//     );

//     /**
//      * @description gets Phantom provider, if it exists
//      */
//     const getProvider = (): PhantomProvider | undefined => {
//         if ("solana" in window) {
//             // @ts-ignore
//             const provider = window.solana;
//             if (provider.isPhantom) return provider;
//         }
//     };

//     /**
//      * @description prompts user to connect wallet if it exists
//      */
//     const connectWallet = async () => {
//         // @ts-ignore
//         const { solana } = window;

//         if (solana) {
//             try {
//                 const response = await solana.connect();
//                 // console.log("wallet account ", response.publicKey.toString());
//                 setWalletKey(response.publicKey.toString());
//                 props.onAddressChange(response.publicKey.toString());

//             } catch (err) {
//                 // { code: 4001, message: 'User rejected the request.' }
//                 disconnectWallet();
//                 props.onAddressChange("");

//             }
//         }
//     };

//     /**
//      * @description disconnect Phantom wallet
//      */
//     const disconnectWallet = async () => {
//         // @ts-ignore
//         const { solana } = window;

//         if (walletKey && solana) {
//             await (solana).disconnect();
//             await provider.disconnect();
//             setWalletKey(undefined);
//             localStorage.clear();
//             // props.onDisconnectComplete();
//         }
//     };

//     // detect phantom provider exists
//     useEffect(() => {
//         const provider = getProvider();

//         if (provider) setProvider(provider);
//         else setProvider(undefined);
//     }, []);


//     useEffect(() => {

//         if (props.connect) {
//         connectWallet()

//     }


//     }, [props.connect])


//     useEffect(() => {

//         if (walletKey)
//             disconnectWallet();


//     }, [walletKey])


//     return (
//         <></>
//     );
// }

// export default PhantomWallet;
